module.exports = __webpack_public_path__ + "img/52.1970d5d7.webp";